var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.848 5.032a.703.703 0 01.966 0l7.76 7.439v10.192c0 .736-.615 1.333-1.374 1.333h-2.747c-.758 0-1.374-.597-1.374-1.333v-7.999h-5.495v8c0 .735-.615 1.332-1.373 1.332H6.463c-.76 0-1.373-.597-1.373-1.333V12.47l7.758-7.438zM20.888 0v6.363l4.807 4.666a.98.98 0 010 1.415c-.402.39-1.055.39-1.457 0L14.06 2.564a1.056 1.056 0 00-1.456 0l-10.178 9.88c-.403.39-1.055.39-1.458 0a.98.98 0 010-1.415L11.633.68a2.463 2.463 0 013.398 0l3.796 3.684V0h2.06z",
    fill: "#28C9C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/homeIcon.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };